export const typesChain = {};
